// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback_page {
    display: flex;
    align-items: left;
    justify-content: left;
    padding-bottom: 100px;
}

.feedback_form_content {
    grid-row-gap: 25px;
    flex-direction: column;
    display: flex;
}

.feedback_title {
    max-width: 650px;
    border-style: none;
    margin-top: 42px;
    margin-bottom: 15px;
    font-size: 36px;
    font-weight: 500;
    line-height: 42px;
}

.feedback_item {
  display: flex;
  grid-row-gap: 12px;
  flex-direction: column;
  text-align: left;
}

.feedback_page_input {
    color: #666;
    margin-bottom: 8px;
    font-family: Helvetica, sans-serif;
    font-size: 16px;
    padding: 10px;
    font-weight: 400;
    line-height: 21px;
    display: block;
}

.feedback_page_textarea {
    height: 180px;
    min-height: 180px;
    object-fit: fill;
    border-radius: 5px;
    margin-bottom: 0;
    padding: 16px 20px;
    overflow: auto;
}

.file_upload {
    display: flex;
}

.file_upload_input {
    opacity: 0;
}

.file_upload_text {
    font-size: 16px;
    color: #4985FF;
    margin-right: 10px;
    border-bottom: 1px solid #4986ff80;
    transition: 0.3s all;
    cursor: pointer;
}

.file_upload_text:hover {
    transition: 0.3s all;
    color: rgb(247, 78, 78);
    border-bottom: 1px solid rgb(247, 78, 78);
}
`, "",{"version":3,"sources":["webpack://./src/pages/feedbackPage/ui/FeedbackPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,yCAAyC;AAC7C","sourcesContent":[".feedback_page {\n    display: flex;\n    align-items: left;\n    justify-content: left;\n    padding-bottom: 100px;\n}\n\n.feedback_form_content {\n    grid-row-gap: 25px;\n    flex-direction: column;\n    display: flex;\n}\n\n.feedback_title {\n    max-width: 650px;\n    border-style: none;\n    margin-top: 42px;\n    margin-bottom: 15px;\n    font-size: 36px;\n    font-weight: 500;\n    line-height: 42px;\n}\n\n.feedback_item {\n  display: flex;\n  grid-row-gap: 12px;\n  flex-direction: column;\n  text-align: left;\n}\n\n.feedback_page_input {\n    color: #666;\n    margin-bottom: 8px;\n    font-family: Helvetica, sans-serif;\n    font-size: 16px;\n    padding: 10px;\n    font-weight: 400;\n    line-height: 21px;\n    display: block;\n}\n\n.feedback_page_textarea {\n    height: 180px;\n    min-height: 180px;\n    object-fit: fill;\n    border-radius: 5px;\n    margin-bottom: 0;\n    padding: 16px 20px;\n    overflow: auto;\n}\n\n.file_upload {\n    display: flex;\n}\n\n.file_upload_input {\n    opacity: 0;\n}\n\n.file_upload_text {\n    font-size: 16px;\n    color: #4985FF;\n    margin-right: 10px;\n    border-bottom: 1px solid #4986ff80;\n    transition: 0.3s all;\n    cursor: pointer;\n}\n\n.file_upload_text:hover {\n    transition: 0.3s all;\n    color: rgb(247, 78, 78);\n    border-bottom: 1px solid rgb(247, 78, 78);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
